import React from 'react'
import EditableSubjectEditingState from './EditingState'
import EditableSubjectNormalState from './NormalState'

const EditableSubject = ({ isEditingSubject, ...rest }) => {
  if (isEditingSubject) return <EditableSubjectEditingState {...rest} />

  return <EditableSubjectNormalState {...rest} />
}

export default EditableSubject
